import { ReactElement } from 'react';

export const HrComponent = (): ReactElement => (
  <div className="w-full h-0 block border-x-0 border-t-2 border-gray-200 m-2" />
);
